import "./instrument";
import * as Sentry from '@sentry/react';
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App.jsx";
import { ToastContainer } from "react-toastify";
import { registerServiceWorker } from "@utils/webPush";
import "react-toastify/dist/ReactToastify.css";

// A tab opened before a deploy still asks for the old chunk names, which are
// gone from the server; a reload fetches the new index.html. The time guard
// stops a reload loop when a chunk is missing for some other reason.
const CHUNK_RELOAD_KEY = "chunkReloadAt";
const CHUNK_RELOAD_COOLDOWN_MS = 10_000;
window.addEventListener("vite:preloadError", () => {
    const lastReloadAt = Number(sessionStorage.getItem(CHUNK_RELOAD_KEY));
    if (Date.now() - lastReloadAt < CHUNK_RELOAD_COOLDOWN_MS) {
        return;
    }
    sessionStorage.setItem(CHUNK_RELOAD_KEY, String(Date.now()));
    window.location.reload();
});

createRoot( document.getElementById( "root" ), {
    onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
        console.warn('Uncaught error', error, errorInfo.componentStack);
    }),
    // Callback called when React catches an error in an ErrorBoundary.
    onCaughtError: Sentry.reactErrorHandler(),
    // Callback called when React automatically recovers from errors.
    onRecoverableError: Sentry.reactErrorHandler(),
}).render(
    <StrictMode>
        <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
            pauseOnHover
            toastStyle={{ zIndex: 20000 }}
            style={{ zIndex: 20000 }}
        />
        <App />
    </StrictMode>,
);

// Web Push service worker (public/sw.js). Push only, it caches nothing.
try {
    await registerServiceWorker();
} catch (err) {
    console.warn("Service worker registration failed", err);
}
